// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3al3Q","vLegacy":"SelectSecondary_vLegacy__2M_2p","error":"SelectSecondary_error__3rI2v","disabled":"SelectSecondary_disabled__1kU_R"};